/*
 * @Author: zj 
 * @Date: 2019-04-17 11:13:22 
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2019-06-25 17:30:28
 */

import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import app from './modules/app'
import nCacheApp from './modules/nCacheApp'
import api from './modules/api'

Vue.use(Vuex)

const store = new Vuex.Store({
    modules: {
        app,
        nCacheApp,
        api
    },
    getters
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js